export default __webpack_public_path__ + "static/media/signup-icon-professional-inactive.c038a335.svg";